import React from "react";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";

import styles from "./style.module.scss";
import Honesty from "./logos/honesty";
import Commitment from "./logos/commitment";
import Determination from "./logos/determination";
const WhyPeople = () => {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    return (
        <section className={` mt-32 ${styles["mainContainer"]}`}>
            <div className="pt-20 text-center pb-[73px] ">
                <h2 className="lg:text-4xl text-2xl lg:leading-9 leading-7  font-extrabold">
                    {translate(
                        translations,
                        "several_aboutUsPage_believeInUsTitle",
                    )}
                </h2>
                <p className="lg:max-w-[1095px] max-w-[526px]   lg:mx-auto px-5 mx-auto  font-medium mt-6">
                    {translate(
                        translations,
                        "several_aboutUsPage_believeInUsDescription",
                    )}
                </p>
                <div
                    className={`mt-10 flex flex-col lg:flex-row px-5 lg:px-0  ${styles["shadowStyle"]} gap-4`}
                >
                    <div className="">
                        <div className=" mx-auto sm:w-[204px] sm:h-[202px] w-[102px] h-[101px] ">
                            <Honesty />
                        </div>
                        <h3>
                            {translate(
                                translations,
                                "several_aboutUsPage_HonestyTitle",
                            )}
                        </h3>
                        <p>
                            {translate(
                                translations,
                                "several_aboutUsPage_HonestyDescription",
                            )}
                        </p>
                    </div>
                    <div className="">
                        <div className=" mx-auto sm:w-[204px] sm:h-[202px] w-[102px] h-[101px] ">
                            <Commitment />
                        </div>
                        <h3>
                            {translate(
                                translations,
                                "several_aboutUsPage_CommitmentTitle",
                            )}
                        </h3>
                        <p>
                            {translate(
                                translations,
                                "several_aboutUsPage_CommitmentDescription",
                            )}
                        </p>
                    </div>
                    <div className="">
                        <div className=" mx-auto sm:w-[204px] sm:h-[202px] w-[102px] h-[101px] ">
                            <Determination />
                        </div>
                        <h3>
                            {translate(
                                translations,
                                "several_aboutUsPage_DeterminationTitle",
                            )}
                        </h3>
                        <p>
                            {translate(
                                translations,
                                "several_aboutUsPage_DeterminationDescription",
                            )}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyPeople;
